import styled from 'styled-components';

import { StyledComponent } from '../../interfaces';

import { LabelContainerProps } from './artworkIcon.types';

export const Container: StyledComponent<'div'> = styled.div`
  width: fit-content;
  display: flex;
  cursor: pointer;
`;

export const IconContainer: StyledComponent<'div'> = styled.div`
  margin-right: 14px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const LabelContainer: StyledComponent<'div', LabelContainerProps> = styled.div<LabelContainerProps>`
  font-size: 14px;
  line-height: 18px;
  color: ${({ $color }: LabelContainerProps): string => $color};
`;
